import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '12px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    display: 'none'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      width: '500px !important',
      '& > div:first-child': {
        padding: '4px 10px !important',
      },
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  disableIcon: {
    pointerEvents: 'none',
    color: '#C6C6C6'
  }
}));
export default styles;
